var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data === null)?[_c('span',{staticStyle:{"color":"lightgrey"}},[_vm._v("Нет показателя")])]:[_c('variable-pie',{attrs:{"data":_vm.data,"percent":_vm.percent,"redraw-trigger":_vm.redrawTrigger}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }